import { useState, useEffect } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import Select from 'react-select';

import { Order } from '../../store/order';
import User from '../../store/user';
import { addPaymentMethod, getProductsCartInfo } from '../../utils/analytics';
import PaymentMethodModal from '../PaymentMethodModal/PaymentMethodModal';

import styles, { bgColor, brandColor, bodyDefault } from './OrderPreferences.module.scss';

const style = {
  control: base => ({
    ...base,
    backgroundColor: bgColor,
    outline: 'none',
    border: 'none',
    '&:hover': {
      borderBottom: `2px solid  ${brandColor}`,
    },
    borderBottom: `2px solid ${brandColor}`,
  }),
  valueContainer: base => ({
    ...base,
    padding: '0',
  }),
  singleValue: base => ({
    ...base,
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
    color: brandColor,
  }),
  option: _styles => ({
    ..._styles,
    color: bodyDefault,
  }),
};

const CASH_OPTION = {
  value: 'cash',
  label: (
    <>
      <img className={styles.paymentMethodImg} src="/assets/global/euro.svg" alt="cash" />
      <span>Με μετρητά ή POS στην παραλαβή</span>
    </>
  ),
  text: 'Με μετρητά ή POS στην παραλαβή',
};
const NEW_PAYMENT_CARD_OPTION = [
  {
    value: 'card',
    label: (
      <>
        <img className={styles.paymentMethodImg} src="/assets/global/newCard.png" alt="new card" />
        <span>Online με νέα κάρτα</span>
      </>
    ),
    text: 'Online με νέα κάρτα',
    datacashReference: '',
  },
];

function UserPaymentOptions() {
  const [paymentMethods, setPaymentMethods] = useState();
  const [paymentType, setSelectedPaymentType] = useState();
  const [isPaymentMethodModalVisible, setIsPaymentMethodModalVisible] = useState(false);

  useEffect(() => {
    const user$ = User.subscribe(user => {
      if (!user?._id) {
        setPaymentMethods([CASH_OPTION]);
        setSelectedPaymentType(CASH_OPTION);
        Order.setPaymentType('cash');
        return;
      }
      const newPaymentOption = process.env.hasOnlinePayment ? NEW_PAYMENT_CARD_OPTION : [];

      const createdPaymentMethods = (() => {
        if (user.savedPaymentCards.length !== 0) {
          const paymentCards = user.savedPaymentCards.map(card => {
            return {
              value: 'card',
              label: (
                <>
                  {card.cardScheme && (
                    <img
                      src={`/assets/global/${card.cardScheme.toLowerCase().split(' ')[0]}.svg`}
                      className={styles.paymentMethodImg}
                      alt={card.cardScheme}
                    />
                  )}
                  <span>{card.maskedNumber}</span>
                </>
              ),
              text: `${card.maskedNumber}`,
              datacashReference: card._id,
              cardScheme: card.cardScheme,
            };
          });
          return [CASH_OPTION, ...paymentCards, ...newPaymentOption];
        }
        return [CASH_OPTION, ...newPaymentOption];
      })();
      setPaymentMethods(createdPaymentMethods);

      const _paymentMethods = (() => {
        return [...createdPaymentMethods];
      })();
      setPaymentMethods(_paymentMethods);
      setSelectedPaymentType(_paymentMethods[0]);
      Order.setPaymentType(_paymentMethods[0].value, _paymentMethods[0].datacashReference);
    });

    return () => {
      user$.unsubscribe();
    };
  }, []);

  function onChangePaymentMethod(typeSelected) {
    addPaymentMethod(
      getProductsCartInfo(Order.getValue()?.products),
      Math.round(Order.getValue()?.totalPrice) / 100,
      typeSelected?.value
    );

    setSelectedPaymentType(typeSelected);
    const datacashReference = typeSelected.datacashReference || null;
    Order.setPaymentType(typeSelected.value, datacashReference);
  }
  return (
    <section className={styles.section}>
      <h2 className={styles.preferencesTitle}>ΤΡΟΠΟΣ ΠΛΗΡΩΜΗΣ</h2>
      <p className={styles.instructions}>Επίλεξε πως θα εξοφλήσεις την παραγγελία σου</p>
      <div className={styles.paymentMethodModalContainer}>
        <button
          type="button"
          className={styles.paymentMethodButton}
          onClick={() => {
            setIsPaymentMethodModalVisible(true);
          }}
        >
          <span>{paymentType?.label}</span>
          <MdKeyboardArrowDown className={styles.imgDropdown} alt="arrow" />
        </button>
        <PaymentMethodModal
          isOpen={isPaymentMethodModalVisible}
          setIsOpen={setIsPaymentMethodModalVisible}
          paymentMethods={paymentMethods}
          selectedOption={paymentType}
          onSelect={onChangePaymentMethod}
        />
      </div>
      <div className={styles.paymentMethodSelectContainer} data-cy="payment-method">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="paymentMethod" className={styles.paymentMethodLabel}>
          Τρόπος Πληρωμής
          <span className={styles.labelAsterisk}>*</span>
        </label>
        <Select
          name="paymentMethod"
          inputId="paymentMethod"
          options={paymentMethods}
          onChange={onChangePaymentMethod}
          styles={style}
          className={styles.paymentMethodSelect}
          placeholder=""
          value={paymentType}
          components={{
            IndicatorSeparator: () => null,
          }}
          theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary: bgColor,
              primary25: bgColor,
            },
          })}
        />
      </div>
    </section>
  );
}

export default UserPaymentOptions;
